/* eslint-disable import/first */
import React, { useState, useContext, useEffect } from 'react';
import Hreflang from '../../components/Hreflang';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate, useLocation } from '@reach/router';
import { Grid, Button, Box, Paper } from '@material-ui/core';
import { selectFirstMenu } from 'spwa-ui-library/esm/redux/store/menuSlice';
import { Context } from '../../components/Multi-lang/Wrapper';
import NotLogged from '../../components/NotLogged';
import OrderInfo from '../../components/OrderInfo';
import Header from '../../components/Header';
import LanguageButton from '../../components/LanguageButton';
import NoOrder from '../../components/NoOrder';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import notLoggedInImg from '../TrackOrder/images/noOrdersNew.svg';
import notLoggedInTrackImg from '../TrackOrder/images/notlogin.svg';
import noOrderTrack from '../TrackOrder/images/noordertrack.svg';
import css from './index.module.scss';
import BackButton from '../../components/BackButton';

const { selectDesktop } = Slices.appSlice;
const { selectAllMain } = Slices.categorySlice;
const { getOrder, selectCurrentOrders, getCurrentOrders } = Slices.orderSlice;

export const URLEncode = (inputSrc) => encodeURI(inputSrc?.toLowerCase().replace(/\s/g, '-'));
function OrderHistoryList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const cart = useSelector((state) => state.cart);
  const auth = useSelector((state) => state.auth);
  const context = useContext(Context);
  const location = useLocation();
  const [status, setStatus] = React.useState('initial');

  const [hist, setHist] = React.useState([]);
  const [prevHist, setPrevHist] = React.useState([]);
  const [futureHist, setFutureHist] = React.useState([]);
  const isDesktop = useSelector(selectDesktop);
  const allOrders = useSelector(selectCurrentOrders);
  const menu = useSelector(selectFirstMenu);
  const categories = useSelector(selectAllMain);
  const result = categories?.sort((a, b) => a.position - b.position);
  const exploreMenuPath = `/${context?.locale}/${URLEncode(result[0]?.name)}/${result[0]?.id}`;
  const [count, setCount] = useState(1);
  const [loadSkelton, setLoadSkelton] = useState(true);
  const [loadViewMore, setLoadViewMore] = useState(false);
  const isTrackOrder = location.pathname.includes('/track-order');
  const [shownOrdersCount, setShownOrdersCount] = useState(3);

  const showViewBtn = isTrackOrder ? allOrders.length > shownOrdersCount : count > 1;

  useEffect(() => {
    if (isTrackOrder) {
      dispatch(getCurrentOrders({ page: count })).then((res) => {
        return res;
      });
    }
  }, []);

  // eslint:fix renderTermsList function is created to remove duplicate code
  const renderTermsList = (list) => {
    return list.map((each) => {
      return (
        <Paper className={css.historyWrapper}>
          <OrderInfo orderObj={each} page="history" />
        </Paper>
      );
    });
  };
  // eslint:fix handleClose is defined but is never used
  useEffect(() => {
    if (
      (menu?.id && !auth.guestLogin && cart.status !== 'idle' && status === 'initial') ||
      (loadViewMore && status !== 'initial')
    ) {
      let payload = {
        isActive: 0,
        page: count,
      };
      setLoadViewMore(false);
      dispatch(getOrder(payload))
        .then((resp) => {
          let newList = [...hist];
          let newPrevHist = [...prevHist];
          let newFutureHist = [...futureHist];
          resp.payload.data.data.list.map((each) => {
            newList.push(each);
            newPrevHist.push(each);
            newFutureHist.push(each);
          });
          // eslint:fix map is replaced with forEach
          const uniq = [...new Set(newList)];
          const uniq1 = [...new Set(newPrevHist)];
          const uniq2 = [...new Set(newFutureHist)];
          const currentOrders = uniq.filter(
            (each) => each.isActive === 1 && each?.advanceTime === 0
          );
          const prevOrders = uniq1.filter((each) => each.isActive === 0);
          const futureOrders = uniq2.filter(
            (each) => each?.isActive === 1 && each?.advanceTime !== 0
          );
          setFutureHist(futureOrders);
          setHist(currentOrders);
          setPrevHist(prevOrders);
          setCount(resp.payload.data.data.nextPage);
          setLoadSkelton(false);
        })
        .catch((e) => {
          console.log(e);
        });
      setStatus('loaded');
    }
  }, [
    count,
    dispatch,
    hist,
    prevHist,
    futureHist,
    menu.menuTempId,
    menu.menuId,
    menu.id,
    loadViewMore,
    auth.guestLogin,
    cart.status,
    status,
  ]);

  const navigateToExplore = () => {
    navigate(exploreMenuPath);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const HeaderTitle = ({ isTrackOrder }) => (
    <>
      {!isDesktop ? null : (
        <div className={css.header}>
          <div className={css.mainHeading}>
            <FormattedMessage
              id={isTrackOrder ? 'navigation_trackOrder' : 'navigation_orderHistory'}
              defaultMessage="Order History"
            />
          </div>
          <BackButton handleBack={handleBack} type="cross" />
        </div>
      )}
    </>
  );

  if (auth.guestLogin) {
    return (
      <>
        {!isDesktop ? (
          <Header
            title={
              <FormattedMessage
                id={isTrackOrder ? 'navigation_trackOrder' : 'orders'}
                defaultMessage="Orders"
              />
            }
            actionButtons={[<LanguageButton />]}
          />
        ) : (
          <>
            <HeaderTitle isTrackOrder={isTrackOrder} />
          </>
        )}
        <div className={css.notLoggedIn}>
          {
            <NotLogged
              topbar={false}
              url="/track-order"
              heading={
                <FormattedMessage id="no_orders_available" defaultMessage="No Orders Available" />
              }
              subHeading={
                <FormattedMessage
                  id="login_to_view"
                  defaultMessage="Please login to view the orders"
                />
              }
              img={isTrackOrder ? notLoggedInTrackImg : notLoggedInImg}
            />
          }
        </div>
      </>
    );
  }

  let slicedOrders = [];

  if (Array.isArray(allOrders)) {
    if (loadViewMore) {
      slicedOrders = allOrders.slice(0, shownOrdersCount);
    } else if (allOrders.length > shownOrdersCount) {
      slicedOrders = allOrders.slice(0, shownOrdersCount);
    } else {
      slicedOrders = allOrders;
    }
  }

  const handleViewMoreClick = () => {
    setLoadViewMore(true);
    setShownOrdersCount((prev) => prev + 3);
  };

  const orderData = isTrackOrder ? slicedOrders : hist;

  if (status === 'loaded') {
    return (
      <Grid className={css.root}>
        <Hreflang page="orders" />
        {/* <Header title={<FormattedMessage id="orderhistorylist_title" defaultMessage="Orders" />} /> */}
        {!isDesktop ? (
          <Header
            title={
              <FormattedMessage
                id={isTrackOrder ? 'navigation_trackOrder' : 'navigation_orderHistory'}
                defaultMessage="Orders"
              />
            }
            actionButtons={[<LanguageButton />]}
          />
        ) : (
          <>{isTrackOrder ? null : <HeaderTitle isTrackOrder={isTrackOrder} />}</>
        )}
        <Grid className={css.container}>
          {loadSkelton && orderData.length === 0 && !isTrackOrder && (
            <Box>
              <Skeleton count={isTrackOrder ? 1 : 3} className={css.Skeleton} />
            </Box>
          )}

          {orderData.length > 0 && (
            <>
              {isTrackOrder && <HeaderTitle isTrackOrder={isTrackOrder} />}
              <Grid>
                <Grid className={css.headerText}>
                  <FormattedMessage id="currentOrders" defaultMessage="Current Orders" />
                </Grid>
                {renderTermsList(orderData)}
              </Grid>
            </>
          )}

          {futureHist?.length > 0 && !isTrackOrder && (
            <Grid>
              <Grid className={css.headerText} style={{ paddingTop: '1.5rem' }}>
                <FormattedMessage
                  id="orderhistorylist_futureorder"
                  defaultMessage="Future Orders"
                />
              </Grid>
              {futureHist.map((each) => {
                return (
                  <Paper>
                    <OrderInfo orderObj={each} page="history" />
                  </Paper>
                );
              })}
            </Grid>
          )}
          {prevHist.length > 0 && !isTrackOrder && (
            <Grid>
              <Grid className={css.headerText} style={{ paddingTop: '1.5rem' }}>
                <FormattedMessage
                  id="orderhistorylist_previousorder"
                  defaultMessage="Previous Orders"
                />
              </Grid>
              {renderTermsList(prevHist)}
            </Grid>
          )}

          <>
            {(orderData?.length === 0 || !orderData.length) && isTrackOrder && !auth.guestLogin ? (
              <>
                <HeaderTitle isTrackOrder={isTrackOrder} />
                <Grid className={css.noOrderWrapper}>
                  <NoOrder
                    callback={navigateToExplore}
                    heading={
                      <FormattedMessage id="no_orders_track" defaultMessage="No Orders to Track" />
                    }
                    subHeading={
                      <FormattedMessage
                        id="no_orders_track_subHead"
                        defaultMessage="For now, no active orders available"
                      />
                    }
                    img={noOrderTrack}
                  />
                </Grid>
              </>
            ) : (
              hist.length === 0 &&
              prevHist.length === 0 &&
              futureHist?.length === 0 &&
              !loadSkelton && (
                <>
                  {isTrackOrder ? null : (
                    <NoOrder
                      callback={navigateToExplore}
                      heading={
                        <FormattedMessage id="no_orders_yet" defaultMessage="No Orders Yet!" />
                      }
                      subHeading={
                        <FormattedMessage
                          id="no_track_hisroty_subhead"
                          defaultMessage="Start ordering your favourite items today."
                        />
                      }
                      img={notLoggedInImg}
                    />
                  )}
                </>
              )
            )}
          </>
        </Grid>
        {showViewBtn && (
          <Grid className={css.flexBox}>
            <Button
              variant="outlined"
              color="primary"
              className={css.desktopButton}
              onClick={handleViewMoreClick}
            >
              <FormattedMessage id="view_more" defaultMessage="View More" />
            </Button>
          </Grid>
        )}
        <footer className={css.footer}></footer>
      </Grid>
    );
  } else {
    return isTrackOrder ? null : (
      <Box>
        <Skeleton count={3} className={css.Skeleton} />
      </Box>
    );
  }
}

export default OrderHistoryList;
